import React from 'react';

const QuickActionsBar = () => {
  const actions = [
    {
      title: "BEE HIVES",
      href: "/shop?category=beekeeping",
      imgSrc: "/assets/General/hive1.png",
      alt: "Bee Hives"
    },
    {
      title: "RAW HONEY",
      href: "/shop?category=honey",
      imgSrc: "/assets/General/hive2.png",
      alt: "Raw Honey"
    },
    {
      title: "LEARN BEEKEEPING",
      href: "/learn-beekeeping",
      imgSrc: "/assets/General/hive3.png",
      alt: "Beekeeping"
    }
  ];

  return (
    <div className="w-full py-8"> 
      <div className="max-w-10xl mx-auto px-4 overflow-hidden">
        <div className="flex flex-row gap-5 items-center justify-center">
          {actions.map((action, index) => (
            <div 
              key={index} 
              className="w-auto  flex flex-col items-center group"
              style={{ transform: 'scale(1)', width: 'calc(100% / 2.5)', minWidth: '50px' }}
            >
              <a 
                href={action.href}
                className="w-full flex flex-col items-center transition-transform hover:scale-105"
              >
                <div className="w-[20vw] h-[20Svw] max-w-48 max-h-48">
                  <img
                    src={action.imgSrc}
                    alt={action.alt}
                    className="w-full h-full object-contain"
                  />
                </div>
                <h3 className="text-[2vw] md:text-2xl font-bold  text-center">
                  {action.title}
                </h3>
                {/* <span className="text-orange-500  font-medium group-hover:text-orange-600 text-[1.8vw]">
                  LEARN MORE →
                </span> */}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActionsBar;
